import { CurrencyPipe } from '@angular/common';
import { Pipe, PipeTransform } from '@angular/core';
import { CurrencyCode } from '@lsq-frontend/remote-services/all-java/common-mk0';
import { Money } from '@lsq-frontend/remote-services/all-java/common-mk0';
import { Currency } from '../constants/currency.constants';
import { Table } from '../constants/table.constants';

@Pipe({
    name: 'currencyDash'
})
export class CurrencyDashPipe implements PipeTransform {
    constructor(private currencyPipe: CurrencyPipe) {}

    public transform(
        field?: string | number | Money,
        min: number = null,
        zeroAsNull = false,
        isNegative = false,
        nullDisplayOverride = Table.NullAmount
    ): string {
        const fieldAsMoney = field as Money;
        const fieldAsScalar = field as number;
        let dollarsOrEquivalent: number;
        let currencyCode: string;

        if (fieldAsMoney != null && typeof fieldAsMoney === 'object') {
            dollarsOrEquivalent = +fieldAsMoney.cents / 100;
            currencyCode = fieldAsMoney.currencyCode;

            if (currencyCode === CurrencyCode.UNKNOWN_CURRENCY_CODE) {
                currencyCode = Currency.Usd;
            }
        } else {
            dollarsOrEquivalent =
                typeof fieldAsScalar === 'string' ? +fieldAsScalar : fieldAsScalar;
        }

        const value = min == null ? dollarsOrEquivalent : Math.max(dollarsOrEquivalent, min);

        if (value || (value === 0 && !zeroAsNull)) {
            const pipeValue = this.currencyPipe.transform(
                value,
                currencyCode || Currency.Usd,
                'symbol'
            );
            return isNegative ? `(${pipeValue})` : pipeValue;
        } else {
            return nullDisplayOverride;
        }
    }
}
